import { Empty, Spin } from 'antd';
import { Line } from '@ant-design/plots';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function ReportTrendChart({
  title,
  series = [],
  fields = [],
  loading = false,
  yFormatter,
  height = 320,
}) {
  const { t } = useTranslation('reportPage');

  const chartData = (series || []).flatMap((row) =>
    fields.map((field) => ({
      date: row.date,
      value: Number(row[field.key] || 0),
      type: field.label,
    }))
  );

  if (loading) {
    return (
      <div className="bg-white rounded-xl border border-gray-200 p-4 min-h-[320px] flex items-center justify-center">
        <Spin />
      </div>
    );
  }

  if (!series?.length) {
    return (
      <div className="bg-white rounded-xl border border-gray-200 p-4">
        {title && <div className="font-semibold mb-3">{title}</div>}
        <Empty description={t('noDataAvailable')} />
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4">
      {title && <div className="font-semibold mb-3">{title}</div>}
      <Line
        data={chartData}
        xField="date"
        yField="value"
        colorField="type"
        height={height}
        autoFit
        legend={{ position: 'top-left' }}
        seriesField="type"
        axis={{
          y: {
            label: {
              formatter: (val) =>
                yFormatter ? yFormatter(Number(val)) : String(val),
            },
            grid: {
              line: {
                style: {
                  stroke: '#f0f0f0',
                  lineDash: [4, 4],
                },
              },
            },
          },
          x: {
            label: {
              autoRotate: true,
              style: { fontSize: 10 },
            },
          },
        }}
        tooltip={{
          items: [
            {
              channel: 'y',
              valueFormatter: (val) =>
                yFormatter ? yFormatter(Number(val)) : String(val),
            },
          ],
        }}
        style={{ lineWidth: 2 }}
      />
    </div>
  );
}

ReportTrendChart.propTypes = {
  title: PropTypes.string,
  series: PropTypes.arrayOf(PropTypes.object),
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  loading: PropTypes.bool,
  yFormatter: PropTypes.func,
  height: PropTypes.number,
};
